// host -> viewer 의 임의 callback (returnFunc 문자열 기반) 을 mode-aware 로 호출.
//
// returnFunc 포맷:
//   - `singleUse.<funcName>` — `createSingleUseFunc` 가 생성한 1 회용 콜백. inner mode 에서는
//     viewer/host 가 같은 window context 라 helper 의 모듈 내부 `localStore` 가 진실의 소스.
//     `window.singleUse.<funcName>` 패턴으로는 접근 불가능 → `callSingleUse` helper 가
//     모듈 store 를 직접 조회.
//   - `webObj.<funcName>` 등 — viewerWindow 의 nested property chain. iframe mode 에서
//     viewer iframe 의 contentWindow.X.Y... 패턴.
//
// 본 helper 는 viewerExt 의 `callCBStr` 분기 (isInnerMode 검사 + iframe chain resolution)
// 를 단일 owner 로 통합. 양 mode 호출자가 동일 시그니처로 호출.

import { callSingleUse } from './singleUse'

export function callViewerCallback(viewerWindow: Window, cbStr: string, params: unknown[]): void {
  // inner mode — viewer 가 host React 트리에 직접 마운트되어 같은 window context 공유.
  // `singleUse.X` 형식만 의미. 그 외 chain 은 host (viewerExt) 가 이미 직접 접근 가능.
  if (viewerWindow === window) {
    callSingleUse(cbStr, params[0])
    return
  }
  // iframe mode — viewer iframe 의 contentWindow.<chain> 따라가기.
  const callbackArr = cbStr.split('.')
  let funcObj: unknown = viewerWindow
  for (const item of callbackArr) {
    funcObj = funcObj != null ? (funcObj as Record<string, unknown>)[item] : undefined
  }
  // singleUse 콜백이 TTL sweep 으로 회수된 뒤 늦게 도착한 응답은 함수가 없으므로 무시.
  if (typeof funcObj !== 'function') {
    console.warn(' --- callViewerCallback - callback not found (swept or stale) : ', cbStr)
    return
  }
  ;(funcObj as (...args: unknown[]) => void).apply(viewerWindow, params)
}
